import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Grid, makeStyles, Typography } from '@material-ui/core';

import { formatPrice } from 'common/utils';

import { FieldInfo } from 'common/components/index';

import inputLabels from 'common/messages/inputLabels';
import servicesMessages from 'modules/services/messages/messages';
import { IPaymentSplitting } from 'modules/services/interfaces/packages';
import CheckCrossIcon from 'common/components/CheckCrossIcon/CheckCrossIcon';

const useStyles = makeStyles(() => ({
  splitStatus: {
    display: 'flex',
    alignItems: 'center',
  },
}));

interface IProps {
  splitting: IPaymentSplitting;
}

const SplitPaymentSectionView = ({ splitting }: IProps): JSX.Element => {
  const classes = useStyles();

  const { allow: allowSplitting, paymentEditableNumber, paymentEditableSplits } = splitting;

  return (
    <>
      <Grid item xs={12} className={classes.splitStatus}>
        <Typography component="p" variant="h5">
          <FormattedMessage {...servicesMessages.splitEachPaymentLabel} />
        </Typography>
        <CheckCrossIcon value={allowSplitting} />
      </Grid>

      {allowSplitting && (
        <>
          <Grid item xs={4}>
            <FieldInfo
              label={<FormattedMessage {...inputLabels.payments} />}
              description={`${paymentEditableNumber?.value}`}
            />
          </Grid>

          {paymentEditableSplits?.map((splitPaymentItem, index) => {
            return (
              <Grid item xs={4} key={splitPaymentItem.order}>
                <FieldInfo
                  label={`#${index + 1}`}
                  description={formatPrice(splitPaymentItem.value)}
                />
              </Grid>
            );
          })}
        </>
      )}
    </>
  );
};

export default SplitPaymentSectionView;
